import React, { useState, useEffect } from 'react';
import axios from 'axios';
import styles from '../styles/ProductManager.module.css';
import { useNavigate } from 'react-router-dom';

const ProductManager = () => {
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [filters, setFilters] = useState({
    name: '',
    marca: '',
    polos: '',
    precoMin: '',
    precoMax: '',
    tensao: '',
  });
  const [marcas, setMarcas] = useState([]); // Lista de marcas cadastradas
  const navigate = useNavigate();

  useEffect(() => {
    fetchProducts();
    fetchMarcas();
  }, []);

  const fetchProducts = async () => {
    try {
      const response = await axios.get('https://crmesquita.com.br/api/produtos/');
      setProducts(response.data);
      setFilteredProducts(response.data); // Inicialmente, todos os produtos são exibidos
    } catch (error) {
      console.error('Erro ao buscar produtos:', error);
    }
  };

  const fetchMarcas = async () => {
    try {
      const response = await axios.get('https://crmesquita.com.br/api/marcas/');
      setMarcas(response.data);
    } catch (error) {
      console.error('Erro ao buscar marcas:', error);
    }
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters({ ...filters, [name]: value });
  };

  const applyFilters = () => {
    let filtered = products;

    // Filtra por nome
    if (filters.name) {
      filtered = filtered.filter((product) =>
        product.nome.toLowerCase().includes(filters.name.toLowerCase())
      );
    }

    // Filtra por marca
    if (filters.marca) {
      filtered = filtered.filter(
        (product) => product.marca?.nome === filters.marca
      );
    }

    // Filtra por polos
    if (filters.polos) {
      filtered = filtered.filter((product) =>
        product.polos.toString().includes(filters.polos)
      );
    }

    // Filtra por tensão
    if (filters.tensao) {
      filtered = filtered.filter((product) =>
        product.tensao.toLowerCase().includes(filters.tensao.toLowerCase())
      );
    }

    // Filtra por preço mínimo
    if (filters.precoMin) {
      filtered = filtered.filter(
        (product) => parseFloat(product.preco) >= parseFloat(filters.precoMin)
      );
    }

    // Filtra por preço máximo
    if (filters.precoMax) {
      filtered = filtered.filter(
        (product) => parseFloat(product.preco) <= parseFloat(filters.precoMax)
      );
    }

    setFilteredProducts(filtered);
  };

  const handleDelete = async (productId) => {
    try {
      await axios.delete(`https://crmesquita.com.br/api/produtos/${productId}/`);
      setProducts(products.filter((product) => product.id !== productId));
      setFilteredProducts(filteredProducts.filter((product) => product.id !== productId));
      alert('Produto excluído com sucesso!');
    } catch (error) {
      console.error('Erro ao excluir produto:', error);
      alert('Erro ao excluir o produto.');
    }
  };

  return (
    <div className={styles['product-manager-container']}>
      <h1 className={styles['product-manager-title']}>Gerenciar Produtos</h1>

      {/* Filtros */}
      <div className={styles['product-manager-filters']}>
        <div className={styles['filter-group']}>
          <label htmlFor="name">Nome</label>
          <input
            type="text"
            id="name"
            name="name"
            value={filters.name}
            onChange={handleFilterChange}
            placeholder="Buscar por nome"
          />
        </div>
        <div className={styles['filter-group']}>
          <label htmlFor="marca">Marca</label>
          <select
            id="marca"
            name="marca"
            value={filters.marca}
            onChange={handleFilterChange}
          >
            <option value="">Todas as Marcas</option>
            {marcas.map((marca) => (
              <option key={marca.id} value={marca.nome}>
                {marca.nome}
              </option>
            ))}
          </select>
        </div>
        <div className={styles['filter-group']}>
          <label htmlFor="polos">Polos</label>
          <input
            type="number"
            id="polos"
            name="polos"
            value={filters.polos}
            onChange={handleFilterChange}
            placeholder="Ex: 2, 4, 6"
          />
        </div>
        <div className={styles['filter-group']}>
          <label htmlFor="tensao">Tensão</label>
          <input
            type="text"
            id="tensao"
            name="tensao"
            value={filters.tensao}
            onChange={handleFilterChange}
            placeholder="Ex: 220V, 380V"
          />
        </div>
        <div className={styles['filter-group']}>
          <label htmlFor="precoMin">Preço Mínimo</label>
          <input
            type="number"
            id="precoMin"
            name="precoMin"
            value={filters.precoMin}
            onChange={handleFilterChange}
            placeholder="Ex: 100"
          />
        </div>
        <div className={styles['filter-group']}>
          <label htmlFor="precoMax">Preço Máximo</label>
          <input
            type="number"
            id="precoMax"
            name="precoMax"
            value={filters.precoMax}
            onChange={handleFilterChange}
            placeholder="Ex: 1000"
          />
        </div>
        <button className={styles['apply-filters-button']} onClick={applyFilters}>
          Aplicar Filtros
        </button>
      </div>

      {/* Lista de Produtos */}
      <div className={styles['product-grid']}>
        {filteredProducts.map((product) => (
          <div key={product.id} className={styles['product-card']}>
            <h3 className={styles['product-name']}>{product.nome}</h3>
            {product.marca?.imagem ? (
              <img
                src={product.marca.imagem}
                alt={product.marca.nome}
                className={styles['product-image']}
              />
            ) : (
              <div className={styles['product-placeholder']}>Sem imagem</div>
            )}
            <p className={styles['product-price']}>Preço: R$ {product.preco}</p>
            <p className={styles['product-stock']}>Estoque: {product.estoque}</p>
            <p className={styles['product-brand']}>Marca: {product.marca?.nome || 'N/A'}</p>
            <div className={styles['product-actions']}>
              <button
                className={styles['edit-button']}
                onClick={() => navigate(`/funcionarios/editar-produto/${product.id}`)}
              >
                Editar
              </button>
              <button
                className={styles['delete-button']}
                onClick={() => handleDelete(product.id)}
              >
                Excluir
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProductManager;